/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { PageMetadata } from './PageMetadata';
import {
    PageMetadataFromJSON,
    PageMetadataFromJSONTyped,
    PageMetadataToJSON,
    PageMetadataToJSONTyped,
} from './PageMetadata';
import type { PublisherDTO } from './PublisherDTO';
import {
    PublisherDTOFromJSON,
    PublisherDTOFromJSONTyped,
    PublisherDTOToJSON,
    PublisherDTOToJSONTyped,
} from './PublisherDTO';

/**
 * 
 * @export
 * @interface PagedModelPublisherDTO
 */
export interface PagedModelPublisherDTO  {
    /**
     * 
     * @type {Array<PublisherDTO>}
     * @memberof PagedModelPublisherDTO
     */
    content?: Array<PublisherDTO>;
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelPublisherDTO
     */
    page?: PageMetadata;
}

/**
 * Check if a given object implements the PagedModelPublisherDTO interface.
 */
export function instanceOfPagedModelPublisherDTO(value: object): value is PagedModelPublisherDTO {
    return true;
}

export function PagedModelPublisherDTOFromJSON(json: any): PagedModelPublisherDTO {
    return PagedModelPublisherDTOFromJSONTyped(json, false);
}

export function PagedModelPublisherDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedModelPublisherDTO {
    if (json == null) {
        return json;
    }
    return {
        
              'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(PublisherDTOFromJSON)),
                  'page': json['page'] == null ? undefined : PageMetadataFromJSON(json['page']),
    };
}

export function PagedModelPublisherDTOToJSON(json: any): PagedModelPublisherDTO {
    return PagedModelPublisherDTOToJSONTyped(json, false);
}

export function PagedModelPublisherDTOToJSONTyped(value?: PagedModelPublisherDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'] == null? value['content']: (value['content'] as Array<any>).map(PublisherDTOToJSON),
        'page': PageMetadataToJSON(value['page']),
    };
}


